import React from "react";
import { PatientData } from "../Contexts";

export default function CallVipLink() {
  const patient = React.useContext(PatientData);
  return (
    <>
      <a className="vip-number" href={`tel:${patient.vip_number}`}>
        {patient.vip_number}
      </a>
    </>
  );
}
